import { useSimpleError as useError } from '@ts-private/apollo-tools-ts';
import { useToast } from 'utils/hooks';

export const useSimpleError = () => {
  const addToast = useToast();
  const showError = useError(addToast);
  return showError;
};
